export const getMergedTagOptions = ({ baseTags = [], createdTags = [] }) =>
  baseTags
    .map((tag) => ({ value: tag, label: tag.title }))
    .concat(
      (createdTags || []).map((tag) => {
        return { value: tag, label: tag.title };
      })
    )
    .filter((v, i, a) => a.indexOf(v) === i) || [];
